import { render, staticRenderFns } from "./ClinicExpense.vue?vue&type=template&id=028ffc4a"
import script from "./ClinicExpense.vue?vue&type=script&lang=js"
export * from "./ClinicExpense.vue?vue&type=script&lang=js"
import style0 from "./ClinicExpense.vue?vue&type=style&index=0&id=028ffc4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports